
import AxiosApiClient from './AxiosApiClient';

import love_and_light_image from '../../assets/frontend/images/love_&_light.png';

const LIKE_KEY = 'romergence_liked_tracks';

// helper for API backend selection
const getAuthApi = () => {
    return localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== ''
        ? localStorage.getItem('auth_api')
        : 'phpLaravel';
};

export const readAlbum = (random_id, type, setViewMode, setIsLoading, setAlbum, navHistory, swal) => {

    setIsLoading(true);

    // --------------------------------------------
    // NEW: Handle "liked" album built from storage
    // --------------------------------------------
    if (type === 'liked') {
        const safeLikedMap = JSON.parse(localStorage.getItem(LIKE_KEY)) || [];

        const likedTracksArray =
            Array.isArray(safeLikedMap.tracks)
                ? safeLikedMap.tracks
                : []; // normalize

        if (likedTracksArray.length > 0) {
            setAlbum(safeLikedMap);
            setViewMode('view_liked_tracks');
            setIsLoading(false);
        } else {
            swal("Error", "Liked Songs & Demos does not exists. Load an album or demos to like a song or demo", "error");
            setAlbum(null);
            setViewMode('none');
            setIsLoading(false);
            navHistory('/home');
        }

        return;
    }

    const fetchApiDataReadAlbum = async () => {
        try {
            const { getBearerToken, makeRequestWithHeaders } = AxiosApiClient({
                apiBackend: getAuthApi(),
                token: localStorage.getItem('auth_token'),
            });

            await getBearerToken();
            const response = await makeRequestWithHeaders('get', '/api/read_album/' + process.env.REACT_APP_NAME + '/' + random_id + '/' + type, null, {
                params: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
                },
            });

            setApiDataReadAlbum(response, "AlbumService", { random_id, type, setViewMode, setIsLoading, setAlbum, navHistory, swal });
        } catch (error) {
            handleApiErrorReadAlbum(error, "AlbumService", { random_id, type, setViewMode, setIsLoading, setAlbum, navHistory, swal });
        }
    };

    fetchApiDataReadAlbum();
};

function setApiDataReadAlbum(response, theFunction, { random_id, type, setViewMode, setIsLoading, setAlbum, navHistory, swal }) {
    console.log(theFunction + ': ', random_id + '-' + type);
    if (response && response.data) {
        if (response.data.status === 200) {//HTTP_OK
            console.log(theFunction + ': ', response.data.message);

            setViewMode('view_album');
            setAlbum(response.data.album);
            setIsLoading(false);
        } else if (response.data.status === 404) {//HTTP_NOT_FOUND
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setViewMode('none');
            setAlbum(null);
            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setViewMode('none');
            setAlbum(null);
            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else {//more errors
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setViewMode('none');
            setAlbum(null);
            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        }
    }

    setIsLoading(false);
}

function handleApiErrorReadAlbum(error, theFunction, { random_id, type, setViewMode, setIsLoading, setAlbum, navHistory, swal }) {
    console.log(theFunction + ': ', random_id + '-' + type);
    console.log(theFunction + ' error: ', error + ' back-end api call error');

    setViewMode('none');
    setAlbum(null);
    setIsLoading(false);
    swal("Error", error.toString(), "error");
    navHistory('/home');
}